import { Languages } from 'lucide-react';
import { useLocale } from '@/shared/lib/i18n/locale-context';

/**
 * Arabic or English, switched on the spot.
 *
 * ⚠️ **The template has no such control, and §23.10 requires one.** TailAdmin is an English product
 * with a light/dark toggle; the association's panel is read in Arabic by a control room and in
 * English by whoever is auditing it, and the flip happens at runtime — `dir` changes on the
 * document, every logical utility mirrors, and the map's RTL text plugin takes over. There is
 * nowhere else in the shell to put a control that affects every screen.
 *
 * ⚠️ Labelled with the language it switches TO, not the one you are in. A button reading "العربية"
 * while the page is already Arabic is a button nobody presses on purpose.
 */
export default function LanguageToggle() {
  const { t, toggleLocale } = useLocale();

  return (
    <button
      type="button"
      onClick={toggleLocale}
      className="hover:text-dark-900 relative flex h-11 w-11 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
      title={t.app.language}
    >
      <Languages aria-hidden className="size-5" />
      <span className="sr-only">{t.app.language}</span>
    </button>
  );
}
